import { action } from "satcheljs";

const resetTagsStore = action(
    "RESET_TAGS_STORE", () => ({})
);

export default resetTagsStore;
